// extracted by mini-css-extract-plugin
var _1 = "QuestionMarkStyle-module__question-mark___tQrML";
var _2 = "QuestionMarkStyle-module__question-mark-small___LKFKw";
var _3 = "QuestionMarkStyle-module__question-mark-white___YIIsL";
var _4 = "QuestionMarkStyle-module__question-mark___tQrML";
var _5 = "QuestionMarkStyle-module__question-mark-small___LKFKw";
var _6 = "QuestionMarkStyle-module__question-mark-white___YIIsL";
export { _1 as "question-mark", _2 as "question-mark-small", _3 as "question-mark-white", _4 as "questionMark", _5 as "questionMarkSmall", _6 as "questionMarkWhite" }
